import theme from 'styles/theme';

import { RiskSeverity } from './risk/risk-severity.enum';
import { RiskIndicator } from 'components/common/RiskIndicator/RiskInicator';

export const RiskScore = {
  [RiskSeverity.LOW]: 29,
  [RiskSeverity.HIGH]: 89,
  [RiskSeverity.MEDIUM]: 69,
  [RiskSeverity.CRITICAL]: 100,
};

export const serverRiskScoreToRiskSeverity = {
  [RiskSeverity.LOW.toLowerCase()]: RiskSeverity.LOW,
  [RiskSeverity.HIGH.toLowerCase()]: RiskSeverity.HIGH,
  [RiskSeverity.MEDIUM.toLowerCase()]: RiskSeverity.MEDIUM,
  [RiskSeverity.CRITICAL.toLowerCase()]: RiskSeverity.CRITICAL,
};

export const riskScoresOptions = [
  {
    index: 0,
    label: RiskSeverity.CRITICAL,
    value: RiskSeverity.CRITICAL,
    icon: () => <RiskIndicator score={RiskScore[RiskSeverity.CRITICAL]} />,
  },
  {
    index: 1,
    label: RiskSeverity.HIGH,
    value: RiskSeverity.HIGH,
    icon: () => <RiskIndicator score={RiskScore[RiskSeverity.HIGH]} />,
  },
  {
    index: 2,
    label: RiskSeverity.MEDIUM,
    value: RiskSeverity.MEDIUM,
    icon: () => <RiskIndicator score={RiskScore[RiskSeverity.MEDIUM]} />,
  },
  {
    index: 3,
    label: RiskSeverity.LOW,
    value: RiskSeverity.LOW,
    icon: () => <RiskIndicator score={RiskScore[RiskSeverity.LOW]} />,
  },
];

export const defaultRiskScoreStatsData = {
  [RiskSeverity.CRITICAL]: {
    count: 0,
    label: RiskSeverity.CRITICAL,
    value: RiskSeverity.CRITICAL,
    color: theme.colors.severity4,
  },
  [RiskSeverity.HIGH]: {
    count: 0,
    label: RiskSeverity.HIGH,
    value: RiskSeverity.HIGH,
    color: theme.colors.severity3,
  },
  [RiskSeverity.MEDIUM]: {
    count: 0,
    label: RiskSeverity.MEDIUM,
    value: RiskSeverity.MEDIUM,
    color: theme.colors.severity2,
  },
  [RiskSeverity.LOW]: {
    count: 0,
    label: RiskSeverity.LOW,
    value: RiskSeverity.LOW,
    color: theme.colors.severity0,
  },
};
